<template>
  <div class="service-section-container" v-if="dataList.length>0">
      <section-title :text="title" :mess="mess"/>
      <div class="section-main">
        <span class="item-menu" v-for="(da,index) in dataList" :key="index" @click="changeTab(index)" :class="active==index?'active':''">
          {{ da.tabName }}
        </span>    
      </div>
      <div class="section-container">
              <h2 class="section-container-title">{{ dataList[active].tabName }}</h2>
              <div class="section-container-text">{{ dataList[active].tabMess }}</div>
            <div class="item-container">
                <a v-for="item in dataList[active].child" :key="item.name" class="cls-item" :class="[item.link == 'https://survey.jd.com/'?'cls-item-last':'']" :href="item.link" target="_blank">
                    <div>{{item.name}}</div>
                </a>
            </div>
            <div class="item-img">
              <img class="cls-img-icon" :src="dataList[active].img"/>
          </div>
      </div>
  </div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle.vue";
export default {
name: "serviceSection",
components: {
  sectionTitle: sectionTitle
},
props: {
  title: {
    type: String,
    default: ""
  },
  mess: {
    type: String,
    default: ""
  },
  dataList: {
    type: Array,
    default: () => []
  }
},
data() {
  return {
    active:0
  }
},
methods:{
  changeTab(idx){
      this.active = idx
  }
}
};
</script>

<style lang="scss" scoped>
.service-section-container {
  width: 100%;
  height: 860px;
  padding: 86px 0 81px;
  background: linear-gradient(180deg, rgba(240, 242, 255, 1) 0%, rgba(251, 252, 255, 1) 48.13%, rgba(255, 255, 255, 1) 100%);
  

  .section-main {
    width: 1268px;
    margin: 31px auto 0;
    display: flex;
    justify-content: center;
    .item-menu {
      width: 299px;
      height: 87px;
      display:inline-block;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 0px 1px 10px 5px #FFFFFF inset;
      color:#6F6FFF;
      text-align: center;
      line-height:87px;
      cursor:pointer;
      font-size: 24px;
    }
    .item-menu:first-child {
      border-radius: 12px 0px 0px 12px;
    }
    .item-menu:last-child {
      border-radius: 0px 12px 12px 0px;
    }
    .item-menu:hover {
      background: linear-gradient(360deg, rgba(49, 71, 255, 1) 0%, rgba(72, 142, 255, 1) 100%);
      box-shadow: 0px 1px 6px rgba(255, 255, 255, 0.6) inset;
      color:#fff;
    }
    .item-menu.active {
      background: linear-gradient(360deg, rgba(49, 71, 255, 1) 0%, rgba(72, 142, 255, 1) 100%);
      box-shadow: 0px 1px 6px rgba(255, 255, 255, 0.6) inset;
      color:#fff;
    }
  }
 .section-container{
    width: 1200px;
    margin: 55px auto 0;
    .section-container-title{
      text-align:center;
      margin-bottom: 20px;
      font-size: 26px;
    }
    .section-container-text{
      text-align:center;
      margin-bottom: 10px;
      font-size: 14px;
    }
    .item-img{
       img{
        width: 100%;
      }
    }
    .item-container{
      width: 1200px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .cls-item{
        min-width:145px;
        padding: 10px 10px;
        border-radius:25px;
        background: linear-gradient(to bottom, #fafafa,#f8fbff, #eaeffa, #b0c9fe);
        text-align:center;
        margin: 10px;
        font-size: 15px;
        font-weight: 600;
        color: #000000;
      }
      .cls-item:hover{
        color:#3247ff;
      }
      .cls-item-last{
        min-width:145px;
        padding: 10px 30px;
      }
    }
   
    }
}
</style>

